import React from 'react';
// Components
import { Portal } from 'components/Portal';

type Props = {
  children: React.ReactNode;
  opacityClass?: string;
  background?: string;
}

const Dialog:React.FC<Props> = ({
  // Props
  children, opacityClass = '', background = '#000',
}) => {
  return (
    <Portal id="root-dialog">
      <div
        className={`
          fixed top-0 left-1/2 w-full h-full
          flex justify-center items-center bg-opa
          ${opacityClass}
          transform -translate-x-1/2
        `}
        style={{ maxWidth: 420, background }}
      >
        <div className="relative w-full h-full flex flex-col justify-center items-center">
          <React.Fragment>{children}</React.Fragment>
        </div>
      </div>
    </Portal>
  );
}

export default Dialog;


